import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";


const brandDataShape = (form) => {
    let formData = new FormData();
    formData.append('name', form.name);
    formData.append('slug', form.slug);
    if (form.description != null && form.description.trim() !== '') formData.append('description', form.description);
    return formData;
}

export default {
    namespaced: true,
    state: {
        brands: [],
        trash: [],
        brandCategories: [],
        pagination: [],
    },
    mutations: {
        setBrands(state, brands) {
            state.brands = brands
        },
        deleteBrand: (state, brand) => {
            state.brands.splice(findObjectIndex(store.getters['Brand/getBrands'], brand), 1)
            state.trash.splice(findObjectIndex(store.getters['Brand/getTrash'], brand), 1)
        },
        setTrash(state, brands) {
            state.trash = brands
        },
        setBrandCategories(state, categories) {
            state.brandCategories = categories
        },
        setPagination(state, meta) {
            state.pagination = meta
        },
    },
    actions: {
        getBrands({commit}, page = 1) {
            axios.get(`/brand?page=${page}`)
                .then(res => {
                    const data = res.data.data;
                    commit('setBrands', data.data)
                    commit('setPagination', data.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        createBrand({commit}, form) {
            const image = form.image;
            form = brandDataShape(form)
            form.append('image', image);
            axios.post('/brand', form)
                .then(res => {
                    const brand = res.data.data;
                    const brands = {...store.getters['Brand/getBrands'], brand}
                    router.push({name: 'EditBrand', params: {slug: brand.slug}})
                    toast('عملیات با موفقیت انجام شد', 'برند با موفقیت ثبت شد.')
                    commit('setBrands', brands)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        async showBrand({commit}, form) {
            return await axios.get(`/brand/${form.slug}`)
        },
        updateBrand({commit}, form) {

            const brandId = form.id
            const image = form.image
            if (form.image !== undefined) {
                if (form.image.length !== 0) {
                    form = brandDataShape(form)
                    form.append('image', image);
                    form.append('_method', 'PUT')
                } else {
                    form = brandDataShape(form)
                    form.append('_method', 'PUT')
                }
            }

            axios.post(`/brand/${brandId}`, form)
                .then(res => {
                    const brand = res.data.data;
                    if (brand.slug !== router.currentRoute.params.slug) {
                        router.push({name: 'EditBrand', params: {slug: brand.slug}})
                    }
                    toast('عملیات با موفقیت انجام شد', 'برند با موفقیت به روزرسانی شد.')
                    commit('deleteBrand', brand)
                    const brands = {...store.getters['Brand/getBrands'], brand}
                    commit('setBrands', brands)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getTrash({commit}, page = 1) {
            axios.post(`/brand/trash?page=${page}`)
                .then(res => {
                    const brands = res.data.data;
                    commit('setTrash', brands.data)
                    commit('setPagination', brands.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        removeBrand({commit}, brand) {
            axios.delete(`/brand/${brand.id}`)
                .then(res => {
                    const brand = res.data.data;
                    commit('deleteBrand', brand)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteBrand({commit}, brand) {
            axios.delete(`/brand/${brand.id}/force-delete`)
                .then(res => {
                    const brand = res.data.data;
                    commit('deleteBrand', brand)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        restore({commit}, brand) {
            axios.put(`/brand/${brand.id}/restore`)
                .then(res => {
                    const brand = res.data.data;
                    commit('deleteBrand', brand)
                    const brands = {...store.getters['Brand/getBrands'], brand}
                    commit('setBrands', brands)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getBrandFilters({commit}, {brand, page = 1}) {
            axios.get(`/brand/${brand}/categories?page=${page}`)
                .then(res => {
                    const categories = res.data.data;
                    commit('setBrandCategories', categories.data)
                    commit('setPagination', categories.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        async getBrandsWithSlug({commit}, form) {
            return await axios.post(`/brand/find/with/slug`, form)
        },
        searchBrand({commit}, {form, page = 1}) {
            axios.post(`brand/search?page=${page}`, form)
                .then(res => {
                    const data = res.data.data;
                    commit('setBrands', data.data)
                    commit('setPagination', data.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
    getters: {
        getBrands: state => state.brands,
        getTrash: state => state.trash,
        getBrandCategories: state => state.brandCategories,
        getPagination: state => state.pagination,
    }
}